
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 21.333c2.933 0 5.333-2.4 5.333-5.333 0-2.933-2.4-5.333-5.333-5.333-2.933 0-5.333 2.4-5.333 5.333 0 2.933 2.4 5.333 5.333 5.333zm0 5.334c-2.933 0-5.333 2.4-5.333 5.333 0 2.933 2.4 5.333 5.333 5.333 2.933 0 5.333-2.4 5.333-5.333 0-2.933-2.4-5.333-5.333-5.333zm0 16c-2.933 0-5.333 2.4-5.333 5.333 0 2.933 2.4 5.333 5.333 5.333 2.933 0 5.333-2.4 5.333-5.333 0-2.933-2.4-5.333-5.333-5.333z","fill-rule":"evenodd"}})])
          )
        }
      }
    